import {
    getTestStory,
    regressionTest,
} from "../../../../test-utils/regression";

describe("ux-direct-searchbox", async () => {
    it("passes the regression test closed", async () => {
        await regressionTest({
            storyId: getTestStory("direct-searchbox", "direct-searchbox"),
            componentTag: "ux-direct-searchbox",
            pageHeight: 210,
            pageWidth: 550,
        });
    });
});
